import { render, staticRenderFns } from "./TipoStatusForm.vue?vue&type=template&id=a422d144"
import script from "./TipoStatusForm.vue?vue&type=script&lang=js"
export * from "./TipoStatusForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports